import AWS from 'aws-sdk'
import { v4 as uuidv4 } from 'uuid'

export default {
  data () {
    return {
      s3: null,
      fileChooser: null,
      reader: null,
      s3Client: null
    }
  },
  methods: {
    async uploadToMinioMix (bucket, file, dontChangeName) {
      if (this.s3Client === null) {
        this.s3Client = new AWS.S3({
          endpoint: this.$store.getters.value('minioHost'),
          accessKeyId: 'admin',
          secretAccessKey: 'itt0root',
          s3BucketEndpoint: true,
          s3ForcePathStyle: true,
          signatureVersion: 'v4',
          logger: window.console
        })
      }

      return new Promise(resolve => {
        let fileName = file.name
        let dotIndex = file.name.lastIndexOf('.')
        let key = ''
        if (dontChangeName) {
          key = fileName
        } else {
          key = fileName.substring(0, dotIndex) + '__' + uuidv4() + fileName.substring(dotIndex, fileName.length)
        }
        this.s3Client.upload(
          {
            Bucket: bucket,
            Key: key,
            Body: file
          },
          {},
          (err, data) => {
            if (err) {
              console.warn('fail load file to minio')
              resolve(null)
            } else {
              resolve(key)
            }
          }
        )
      })
    },

    getMinioFileUrlMix (bucket, key) {
      if (bucket === undefined || bucket === null || key === undefined || key === null) {
        return ''
      }
      if (this.s3Client === null) {
        this.s3Client = new AWS.S3({
          endpoint: this.$store.getters.value('minioHost'),
          accessKeyId: 'admin',
          secretAccessKey: 'itt0root',
          s3BucketEndpoint: true,
          s3ForcePathStyle: true,
          signatureVersion: 'v4',
          logger: window.console
        })
      }
      let url = this.s3Client.getSignedUrl('getObject', {Bucket: bucket, Key: key})
      return url
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/minioMix.js